export default __webpack_public_path__ + "static/media/pin.543efc31.svg";